import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Icon } from '@codex-brightworld/icons';
import themes from '@codex-brightworld/themes';
import Container from '../Container/Container';

const TYPES = {
  INFO: 'info',
  WARNING: 'warning',
  SUCCESS: 'success',
  ERROR: 'error'
};

const StyledContainer = styled(Container)`
  min-height: 68px;
`;

const Header = styled.div`
  margin-left: 51px;
  margin-bottom: 4px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

const Body = styled.div`
  margin-left: 51px;
`;

const AlertIcon = styled(Icon)`
  float: left;
  width: 35px;
  height: 35px;
`;

/**
 * @tags styled, basics, alert, tooltip, popup
 */
const Alert = props => (
  <StyledContainer data-qa={props.qa} className={props.className} border>
    <AlertIcon icon={`alert_${props.type}`} />
    {props.header && <Header>{props.header}</Header>}
    <Body>
      {props.children}
    </Body>
  </StyledContainer>
);

Alert.displayName = 'Alert';

Alert.propTypes = {
  theme: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(Object.values(TYPES)),
  header: PropTypes.node,
  className: PropTypes.string,
  qa: PropTypes.string
};

Alert.defaultProps = {
  theme: themes.brightworld,
  type: TYPES.INFO,
  header: undefined,
  className: undefined,
  qa: undefined
};

/** @component */
export default Alert;
